import { Dayjs } from "dayjs";
import Helper from "../../Helper";
import { CalendarEvent } from "../../models/CalendarEvent";
import { plotFetch } from "../Helper/ApiRequest";

export function createOrderDelivery(
    teamSubdomain: string,
    projectToken: string,
    orderId: number,
    calendarEvent: CalendarEvent,
    timezone: string
): Promise<CalendarEvent | null> {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain || "projects")}/projects/${projectToken}/orders/${orderId}/order_deliveries`;

    return plotFetch(
        url,
        {
            method: "POST",
            body: JSON.stringify({ calendar_event: calendarEvent.toApiObject() }),
        },
        true
    )
        .then((data) => {
            if (data.ok) {
                return data.json();
            }

            throw new Error("Network error.");
        })
        .then((data) => CalendarEvent.fromApiObject(data, timezone))
        .catch(() => {
            return null;
        });
}

export function updateOrderDeliveryActuals(
    teamSubdomain: string,
    projectToken: string,
    orderId: number,
    deliveryId: number,
    actualStartAt: Dayjs | null,
    actualEndAt: Dayjs | null,
    timezone: string
): Promise<CalendarEvent | null> {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain || "projects")}/projects/${projectToken}/orders/${orderId}/order_deliveries/${deliveryId}`;

    return plotFetch(
        url,
        {
            method: "PUT",
            body: JSON.stringify({
                calendar_event: {
                    actual_start_at: actualStartAt,
                    actual_end_at: actualEndAt,
                },
            }),
        },
        true
    )
        .then((data) => {
            if (data.ok) {
                return data.json();
            }

            throw new Error("Network error.");
        })
        .then((data) => CalendarEvent.fromApiObject(data, timezone))
        .catch(() => {
            return null;
        });
}

export function deleteOrderDelivery(
    teamSubdomain: string,
    projectToken: string,
    orderId: number,
    deliveryId: number
): Promise<boolean> {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain || "projects")}/projects/${projectToken}/orders/${orderId}/order_deliveries/${deliveryId}`;

    return plotFetch(url, { method: "DELETE" }, true)
        .then((data) => {
            if (data.ok) {
                return true;
            }

            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}
